export const EXTERNAL_DELIVERY_COMPANIES = {
  DEELIVERS: 'deelivers',
  GLOVO: 'glovo',
  PIDEPAYA: 'pidepaya',
  PEDIDOS_YA: 'pedidos_ya',
  TWO_GO: 'two_go',
  UBER_DIRECT: 'uber_direct'
};

// eslint-disable-next-line id-length
export const DELIVERY_COMPANIES_THAT_DONT_ACCEPT_TIPS = [
  EXTERNAL_DELIVERY_COMPANIES.DEELIVERS,
  EXTERNAL_DELIVERY_COMPANIES.PIDEPAYA,
  EXTERNAL_DELIVERY_COMPANIES.PEDIDOS_YA,
  EXTERNAL_DELIVERY_COMPANIES.TWO_GO,
  EXTERNAL_DELIVERY_COMPANIES.UBER_DIRECT
];
